import gql from "graphql-tag";

const ARTICLES_QUERY = gql`
  query Articles {
    articles {
      slug
      id
      title
      content
      description
      published
      image {
        url
      }
    }
  }
`;
export default ARTICLES_QUERY;
